import type { KeyboardEvent } from 'react';
import { Send, Loader2 } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';
import { Textarea } from '@/shared/components/ui/textarea';

type MessageComposerProps = {
  value: string;
  onChange: (value: string) => void;
  onKeyDown: (event: KeyboardEvent<HTMLTextAreaElement>) => void;
  onSend: () => void;
  isSending: boolean;
  isSendBlocked: boolean;
};

// The inline FA→SP contact-type picker that used to live here is retired
// (ticket 08) — intent is always resolved before this composer renders, via
// the launch-gate/pre-chat modal or a restored pending-intent record. See
// `usePendingFirstMessageIntent` and `FirstContactIntentFallback`.
export const MessageComposer = ({
  value,
  onChange,
  onKeyDown,
  onSend,
  isSending,
  isSendBlocked,
}: MessageComposerProps) => (
  <div className="p-4 border-t bg-white">
    <div className="flex gap-2">
      <Textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKeyDown}
        placeholder="Type your message..."
        className="resize-none min-h-[60px] max-h-[120px]"
        disabled={isSending}
      />
      <Button
        onClick={onSend}
        disabled={isSendBlocked}
        className="bg-[#026857] hover:bg-[#025247] self-end"
        size="icon"
      >
        {isSending ? (
          <Loader2 className="h-5 w-5 animate-spin" />
        ) : (
          <Send className="h-5 w-5" />
        )}
      </Button>
    </div>
    <p className="text-xs text-gray-500 mt-2">
      Press Enter to send, Shift+Enter for new line
    </p>
  </div>
);
